import type { ContextGuards } from './types.js';

/**
 * @deprecated
 */
export function isRetailLicensee(ctx: ContextGuards) {
  return ctx.profileService.isRetailLicensee();
}
